var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLegendaryWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.76584 9.90471L6.70703 15.7282L8.62497 11.2717L18.9653 7.24618C20.0238 6.83412 20.7938 5.90391 21.001 4.78711L7.76584 9.90471Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6484 2.31641L11.8709 5.58942C11.1007 5.87661 10.59 6.61202 10.5898 7.434L18.5863 4.70314C19.6542 4.33841 20.4425 3.42604 20.6484 2.31641Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.355556 2.31641L9.13302 5.58942C9.9032 5.87661 10.4139 6.61202 10.4141 7.434L2.41765 4.70314C1.34966 4.33841 0.561385 3.42604 0.355556 2.31641Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2361 9.90471L14.2949 15.7282L12.377 11.2717L2.03663 7.24618C0.978155 6.83412 0.208105 5.90391 0.000946045 4.78711L13.2361 9.90471Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4127 0L11.007 1.82905H12.9301L11.3742 2.95947L11.9685 4.78853L10.4127 3.65811L8.85677 4.78853L9.45107 2.95947L7.89518 1.82905H9.81836L10.4127 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegendaryWhite);
export default __webpack_public_path__ + "static/media/LegendaryWhite.d4832cff205b67f07abf2aff4650dcd4.svg";
export { ForwardRef as ReactComponent };